import React from 'react'

import { hooks } from '@front/volcanion'
import { Box } from '@mui/material'
import EquipmentDetail from '@abra/frames/Equipment'

const EquipmentPage = () => {
  const { equipment_id } = hooks.useParams()
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <EquipmentDetail record_id={equipment_id} />
    </Box>
  )
}

export default React.memo(EquipmentPage)
